import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import '../styles/midnight-lab.css';

function PageTransition({ children }) {
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    setIsVisible(false);
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 50);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <div
      style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(10px)',
        transition: 'opacity 0.4s ease-in-out, transform 0.4s ease-in-out',
        minHeight: '100vh'
      }}
    >
      {children}
    </div>
  );
}

export default PageTransition;

